import Vue from 'vue';
// @ts-ignore
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/Vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
// Rich Text Editor
// import plugin
// @ts-ignore
import {TiptapVuetifyPlugin} from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'fa',
});

Vue.config.productionTip = false;

window.addEventListener('storage', async (event: StorageEvent) => {
  const oldValue = JSON.parse(event.oldValue as string);
  const newValue = JSON.parse(event.newValue as string);
  // tslint:disable-next-line:max-line-length
  if (newValue && newValue.user && newValue.user.institution && oldValue && oldValue.user && oldValue.user.institution && (newValue.user.institution.id !== oldValue.user.institution.id || newValue.user.userName !== oldValue.user.userName)) {
    if (router.currentRoute.fullPath !== '/') {
      router.push('/');
    }
    await store.dispatch('userData');
  }
});

new Vue({
  router,
  store,
  // @ts-ignore
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
